import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyApplicationNavigatorPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApplicationNavigatorContainer" */ '../src/ApplicationNavigator/ApplicationNavigatorPage.tsx'
			)
		).ApplicationNavigatorPage,
});
